var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShareMedia(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0007 16.5003C12.0007 18.3413 10.5083 19.8337 8.66732 19.8337C6.82637 19.8337 5.33398 18.3413 5.33398 16.5003C5.33398 14.6594 6.82637 13.167 8.66732 13.167C10.5083 13.167 12.0007 14.6594 12.0007 16.5003Z",
    stroke: "#A020FF",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6667 9.16699L12 13.8337",
    stroke: "#A020FF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6667 23.833L12 19.1663",
    stroke: "#A020FF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3327 25.1663C25.3327 27.0073 23.8403 28.4997 21.9993 28.4997C20.1584 28.4997 18.666 27.0073 18.666 25.1663C18.666 23.3254 20.1584 21.833 21.9993 21.833C23.8403 21.833 25.3327 23.3254 25.3327 25.1663Z",
    stroke: "#A020FF",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3327 7.83333C25.3327 9.67428 23.8403 11.1667 21.9993 11.1667C20.1584 11.1667 18.666 9.67428 18.666 7.83333C18.666 5.99238 20.1584 4.5 21.9993 4.5C23.8403 4.5 25.3327 5.99238 25.3327 7.83333Z",
    stroke: "#A020FF",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareMedia);
export default __webpack_public_path__ + "static/media/ShareMedia.687653d7c2186cc7b5358e70ab75f869.svg";
export { ForwardRef as ReactComponent };